import { render, staticRenderFns } from "./hisWork.vue?vue&type=template&id=0c6ec2fa&"
import script from "./hisWork.vue?vue&type=script&lang=js&"
export * from "./hisWork.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports